<script lang="ts">
    import {Container} from "sveltestrap";
    import {link} from "svelte-spa-router";
    import Footer from "../components/Footer.svelte";
</script>

<div class="container-404">
    <Container>
        <h1>Page not found</h1>
        <p>Go back to <a href="/" use:link>the home page</a></p>
    </Container>
    <Footer/>
</div>

<style>
    .container-404 {
        padding-top: 5vh;
        padding-bottom: 15px;
    }
</style> 
